export default "__VITE_ASSET__By_qj6US__"